<template>
    <div>
      <div class="d-flex align-items-center justify-content-between">
        <div class="w-full dropdown-style" v-if="!isFenomen">
          <v-select
            id="inf_id"
            :options="fenomenList"
            v-model="getInfId"
            :reduce="val => val.value"
            class="w-auto fixed-width btn text-primary p-0 dropdown-toggle btn-outline-primary"
            placeholder="Tüm Fenomenler"
            :clearable="false"
          />
  
        </div>
        <b-dropdown
        :text="nowYear.toString()"
        size="md"
        class="budget-dropdown ml-auto"
        variant="outline-primary"
      >
        <b-dropdown-item
          v-for="year in $globalYears()"
          :key="year"
          @click="selectYear(year)"
          :active="year==nowYear"
        >
          {{ year }}
        </b-dropdown-item>
      </b-dropdown>
          
      </div>
      <div class="mb-2 demo-inline-spacing">


        <b-button
          v-for="(month, index) in diffDateMonth(nowYear)"
          :key="index"
          :variant="index === selectedMonth ? 'primary' : 'outline-primary'"
          @click="updateMonth(index)"
        >
          {{ month }}
        </b-button>
      </div>
      
      <!-- İlgili Siparişler -->
      <order :tableColumns="tableColumns" :checkPayment="true" v-if="getInfId && loadOrders" :params="params" @orders-fetched="handleOrdersFetched" :title="getTitle+ 'İlgili siparişler'"></order>
    </div>
  </template>
    
    <script>
    import { BRow,BFormGroup, BDropdown, BDropdownItem,BCardSubTitle, BCol, BCard, BLink, BTable, BButton } from 'bootstrap-vue'
    import order from '../Orders.vue';
  
    import vSelect from 'vue-select'
  
    const now = new Date();
  
    export default {
      components: {
        BRow,
        BCol,
        BLink,
        BCard,
        BDropdown,
        BDropdownItem,
        BCardSubTitle,
        BFormGroup,
        BButton,
  
        vSelect,
        BTable,
  
        order,
      },
      data() {
        return {
          nowYear:now.getFullYear(),
          orderList: [],
          orderListCopy:[],
          loadOrders: false,
          tableColumns : [
            { key: 'id', sortable: true },
            { key: 'link', label: 'Paylaşım Bilgisi', sortable: true },
            { key: 'created_date', label: 'Sipariş Tarihi', sortable: true },
            { key: 'transaction', label: 'Sipariş No', sortable: true },
            { key: 'amount', label: 'Toplam', sortable: true },
            { key: 'inf_payment_total', label: 'Ödenecek Tutar', sortable: true },
            { key: 'order_status', label: 'Sipariş Durumu', sortable: true },
            { key: 'payment_status', label: 'Ödeme Durumu', sortable: false },
            { key: 'show_details', label: 'DETAY'},
          ],
          fenomenTableColumn:[
            { key: 'id', label: 'ID'},
            { key: 'username', label: 'FENOMEN'},
            { key: 'label', label: 'Adı Soyadı' },
            { key: 'vesting_count', label: 'Hakediş Sipariş Adedi'},
            { key: 'vesting_payment', label: 'Hakediş Toplam Tutar'},
            { key: 'test', label: 'Bekleyen Hakediş Tutarı/Adedi'},
          ],
          selectedMonth: new Date().getMonth(),
          years: ['2024','2023','2022','2021','2020', '2019', '2018'],
          fenomenList:[],
          getInfId:parseInt(this.$route.params.id , 10),
          props:{},
          params:{
            hasFilter:true
          }
        }
      },
      methods: {
        handleOrdersFetched(orders=null) {
            this.orderList=orders
            if(!this.selectedMonth){
              this.orderListCopy = orders;
            }
        },
        async fetchFenomenOptions() {
          try {
            const response = await this.$http.get('/user', {
              params: { user_type: 'influencer', all: true }
            })
            this.fenomenList = response.data.data.map(fenomen => ({
              username: fenomen.username,
              label: fenomen.name_surname,
              value: fenomen.id,
              id: fenomen.id
            }))
            if(!this.getInfId){
              this.getInfId=this.fenomenList[0].id
            }else{
              this.createParams(true)
            }
            // Fenomenler listelendiğinde createparams çalışsın, böylece orders'lar da gelebilir ve eşleşebilir.
           
          } catch (error) {
            console.error('Error fetching fenomen options:', error)
          }
        },
        updateMonth(elementIndex) {
          this.selectedMonth = elementIndex
          this.createParams()
        },
        selectYear(year){
          this.selectedMonth=null
          if(this.nowYear!=year){
            this.loadOrders=true;
            this.nowYear=year;
            this.createParams();
          }
        },
  
        createParams(){
          let params = {
            year:this.nowYear,
            filter: {
              vesting_status: 1,
            },
          }
          if(this.selectedMonth!=null){
            params.month = this.selectedMonth+1; // Ay bilgisini de ekliyoruz
          }
          params['infId'] = this.getInfId;
          this.params=params;
          this.loadOrders=true
        }
      },
      computed: {
        getTitle(){
          let title=''
          const selectedUser = this.fenomenList.find(item => item.id === this.getInfId);
          title+=selectedUser ? selectedUser.label +' - ' : ''; // Öğe yoksa boş döner
          title+=this.selectedMonth ? ' '+this.diffDateMonth(this.nowYear)[this.selectedMonth]+'/' : ''; // Öğe yoksa boş döner
          title+=this.nowYear + ' '
          return title
        },
      },
      watch: {
        getInfId(newValue) {
          this.$router.push({ name: 'vesting-payment', params: { id: newValue } });
          this.createParams();
        },
      },
      created() {
        if(this.isFenomen){
          this.getInfId=this.userData.id
        }
        this.fetchFenomenOptions();
      },
    }
    </script>
    
  
    <style lang="scss">
    @import '@core/scss/vue/libs/vue-select.scss';
    .fixed-width {
      min-width: 230px; /* İhtiyaca göre genişliği ayarlayın */
      width: 100%;
    }
    .dropdown-style{
      .vs__dropdown-toggle{
        border:none; 
      }
      .vs__selected{
        color: var(--indigo) !important;
      }
      .dropdown-toggle::after{
        right: 10px;
        left: inherit;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    </style>